<template>
  <div class="wj_box">
    <div class="wj_header">
      <el-row>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 22, offset: 1 }"
          :md="{ span: 16, offset: 4 }"
          :lg="{ span: 14, offset: 5 }"
          :xl="{ span: 14, offset: 5 }"
          class="wj_header_main"
        >
          <div class="wj_header_left">
            <img
              alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
              src="../../../assets/images/logo2_1.png"
            />
          </div>
          <el-link
            class="wj_header_right_link"
            @click="userOut()"
            v-if="backTarget === 'signin'"
          >
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </el-link>
          <el-link
            class="wj_header_right_link"
            @click="backList()"
            v-if="backTarget === 'list'"
          >
            <span>返回列表</span>
          </el-link>
        </el-col>
      </el-row>
    </div>
    <el-row class="wj_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_body">
          <div class="wj_body_head">
            <h1>{{ answerPaper.QuestionnaireName }}</h1>
          </div>
          <div class="wj_body_head_info">
            <div class="wj_body_head_info_left">
              <span class="wj_body_head_info_left_item">
                题目数量：{{ answerPaper.QuestinsNumber }}
              </span>
              <span
                v-if="answerPaper.QuestionnaireType === 1"
                class="wj_body_head_info_left_item"
              >
                总分：{{ answerPaper.TotalScore }}分
              </span>
              <span
                v-if="
                  answerPaper.QuestionnaireType === 1 &&
                  answerPaper.IsSetPassScore
                "
                class="wj_body_head_info_left_item"
              >
                通过线：{{ answerPaper.PassScore }}分
              </span>
            </div>
            <div
              class="wj_body_head_info_right"
              v-if="answerPaper.QuestionnaireType === 1"
            >
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.IsSubmit"
                style="color: #67c23a"
              >
                已交卷
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="!answerPaper.IsSubmit"
              >
                未交卷
              </span>
            </div>
          </div>
          <el-row v-show="false">
            <el-col
              v-if="answerPaper.QuestionnaireType === 1"
              class="wj_score_box"
              :xs="{ span: 24 }"
              :sm="{ span: 18, offset: 3 }"
              :md="{ span: 16, offset: 4 }"
              :lg="{ span: 16, offset: 4 }"
              :xl="{ span: 12, offset: 6 }"
            >
              <div class="wj_score_item">
                <div class="wj_score_item_content">
                  <div class="">
                    {{ answerPaper.AnswerRightNumber }}
                  </div>
                  <span>答对</span>
                </div>
                <div class="wj_score_item_bottom">
                  共 {{ answerPaper.QuestinsNumber }} 题
                </div>
              </div>
              <div class="wj_score_item">
                <div class="wj_score_item_content">
                  <div
                    class="wj_score_item_font"
                    :style="[
                      {
                        color:
                          answerPaper.AnswerTotalScore >= answerPaper.PassScore
                            ? '#FF6A00'
                            : 'red'
                      }
                    ]"
                  >
                    {{ answerPaper.AnswerTotalScore }}
                  </div>
                  <span
                    ><i
                      class="iconfont icon-fenshudixian"
                      :style="[
                        {
                          color:
                            answerPaper.AnswerTotalScore >=
                            answerPaper.PassScore
                              ? '#FF6A00'
                              : 'red'
                        }
                      ]"
                    ></i
                  ></span>
                </div>
                <div class="wj_score_item_bottom">
                  总分
                  {{ answerPaper.TotalScore }}
                </div>
              </div>
            </el-col>
          </el-row>
          <div
            class="wj_element_box"
            v-for="(element, index) in answerPaper.ElementItems"
            :key="index"
          >
            <div
              class="wj_element"
              :style="[
                {
                  border: element.NoAnswer
                    ? '2px solid #E6A23C'
                    : '2px solid #fff'
                }
              ]"
            >
              <div
                class="wj_element_title_all wj_element_title_duanluo"
                v-if="element.ElementType === 1 && !element.IsOnlyManualShow"
              >
                <span class="show_index">{{ element.ShowIndex }}、</span>
                <div class="wj_element_title" v-html="element.Title"></div>
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType !== 4"
              >
                <span class="show_index">{{ element.ShowIndex }}.</span>
                <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    element.QuestionStem
                  "
                ></div>
                <!-- <div class="wj_element_title">
                  <div v-html="element.QuestionStem"></div>
                  <span class="element_type" v-if="element.QuestionTypeText">
                    【{{ element.QuestionTypeText }}】
                  </span>
                  <span
                    class="element_score"
                    v-if="answerPaper.QuestionnaireType === 1"
                    v-show="false"
                  >
                    （{{ element.QuestionScore }}分）
                  </span>
                </div> -->
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType === 4"
              >
                <span class="show_index">{{ element.ShowIndex }}.</span>
                <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    getBlankBody(element, index)
                  "
                ></div>
                <!-- <div class="wj_element_title">
                  <div
                    class="questionStem"
                    v-html="getBlankBody(element, index)"
                  ></div>
                  <span class="element_type" v-if="element.QuestionTypeText">
                    【{{ element.QuestionTypeText }}】
                  </span>
                  <span
                    class="element_score"
                    v-if="answerPaper.QuestionnaireType === 1"
                    v-show="false"
                  >
                    （{{ element.QuestionScore }}分）
                  </span>
                </div> -->
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 1 || element.QuestionType === 3"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-radio
                    v-model="element.SelectOptionId"
                    :label="optionItem.AnswerPaperOptionId"
                    class="choice"
                    :disabled="
                      element.SelectOptionId !== optionItem.AnswerPaperOptionId
                    "
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-radio>
                </div>
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 2"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-checkbox
                    v-model="optionItem.Selected"
                    class="choice"
                    :disabled="!optionItem.Selected"
                    @change="optionCheckboxChange(optionItem)"
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-checkbox>
                </div>
              </div>

              <div v-if="element.QuestionType === 5">
                <el-input
                  type="textarea"
                  :rows="element.TextHeight"
                  :minlength="element.MinWordNum"
                  :maxlength="element.MaxWordNum"
                  :style="[
                    {
                      width:
                        element.TextWidth == 0
                          ? '100%'
                          : element.TextWidth + 'px'
                    }
                  ]"
                  v-model="element.AnswerElementAnswer"
                  disabled
                >
                </el-input>
              </div>
              <div
                class="judge_question_correct"
                v-if="
                  answerPaper.QuestionnaireType === 1 &&
                  element.ElementType === 2
                "
                v-show="false"
              >
                <div
                  class="judge_question_correct_left"
                  v-if="!element.IsManual"
                >
                  <span v-if="element.AnswerRight">
                    <i class="el-icon-circle-check"></i>
                    回答正确
                  </span>
                  <span
                    v-if="!element.AnswerRight"
                    class="judge_question_correct_error"
                  >
                    <i class="el-icon-circle-close"></i>
                    回答错误
                  </span>
                  <span
                    :style="[
                      { color: element.AnswerRight ? '#67C23A' : 'red' }
                    ]"
                  >
                    +{{ element.AnswerElementScore }}分
                  </span>
                </div>
                <div
                  class="judge_question_correct_left"
                  v-if="element.IsManual"
                >
                  <span class="judge_question_correct_manual">
                    <i class="el-icon-info"></i>
                    人工评分
                  </span>
                  <span style="color: #409eff">
                    +{{ element.AnswerElementScore }}分
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="wj_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_footer_box">
          <div class="hidden-xs-only">
            北京鹏宇成软件技术有限公司 提供技术支持
          </div>
          <div class="wj_footer_right">
            <!-- <span class="wj_footer_right_lable">
              得分：
              <span class="wj_footer_right_score">
                {{ answerPaper.AnswerTotalScore }}
              </span>
              分
            </span> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import answerPaperApi from '../../../api/wj/answerPaper'
export default {
  data () {
    return {
      answerPaper: {},
      backTarget: 'list'
    }
  },
  methods: {
    userOut: function () {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'wj_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        this.$router.push({ name: 'answerLogin', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, qid: this.$route.params.qid } })
      }).catch(() => {

      })
    },
    backList: function () {
      this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
    },
    getAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getCurrentUserAnswerPaper({
        QuestionnaireId: _this.$route.params.qid,
        AnswerPaperId: _this.$route.params.aid
      }).then(data => {
        _this.answerPaper = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getOptionIndex: function (optionSerialNumberType, optionIndex) {
      if (optionSerialNumberType === 2) {
        return String.fromCharCode(65 + optionIndex) + '、'
      } else if (optionSerialNumberType === 3) {
        return String.fromCharCode(65 + optionIndex).toLowerCase() + '、'
      } else {
        return optionIndex + 1 + '、'
      }
    },
    getBlankBody1: function (element) {
      //   const questionStem = ''
      let questionStem = JSON.parse(JSON.stringify(element.QuestionStem))
      questionStem = questionStem.replace(/<p>/g, '')
      questionStem = questionStem.replace(/<\/p>/g, '')
      const stemArray = questionStem.split('___')

      const blankItems = []
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          blankItems.push(item)
        }
      })
      return blankItems
    },
    getBlankBody: function (element, elementIndex) {
      let questionStem = ''
      const stemArray = element.QuestionStem.split('___')

      let optionIndex = 0
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          questionStem = questionStem + item
          if (index < stemArray.length - 1) {
            let blankItemTextWidth = element.OptionItems[optionIndex].TextWidth + 'px'
            if (element.OptionItems[optionIndex].TextWidth === 0) {
              blankItemTextWidth = '100%'
            }
            const blankItemAnswer = element.OptionItems[optionIndex].Answer
            questionStem = questionStem + '<input type="text" id="' + element.AnswerPaperElementId.toLowerCase() + '_' + element.OptionItems[optionIndex].AnswerPaperOptionId.toLowerCase() + '" class="blankInput" style="width:' + blankItemTextWidth + '" value="' + blankItemAnswer + '" maxlength="' + element.OptionItems[optionIndex].MaxWordNum + '" minlength="' + element.OptionItems[optionIndex].MinWordNum + '" disabled />'
            optionIndex++
          }
        }
      })
      return questionStem
    },
    optionCheckboxChange: function (optionItem) {
      optionItem.Selected = true
    }
  },
  created () {
    this.backTarget = this.$route.params.s
    this.getAnswerPaper()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/wj.css';
</style>
